import script from "./listUndanews.vue?vue&type=script&setup=true&lang=js"
export * from "./listUndanews.vue?vue&type=script&setup=true&lang=js"

import "./listUndanews.vue?vue&type=style&index=0&id=87b92b52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87b92b52"]])

export default __exports__